import product1 from "../assets/1.png";
import product2 from "../assets/2.png";
import product3 from "../assets/3.png";
import product4 from "../assets/4.png";
import product5 from "../assets/5.png";
import product6 from "../assets/6.png";
import product7 from "../assets/7.png";
import product8 from "../assets/8.webp";
import product9 from "../assets/9.png";
import product10 from "../assets/10.png";
import product11 from "../assets/11.webp";
import product12 from "../assets/12.png";
import product13 from "../assets/13.png";
import product14 from "../assets/14.png";

export const PRODUCTS = [
    {
        id: 1,
        productName: "IPhone 13",
        price: 899.99,
        productImage: product1,
    },
    {
        id: 2,
        productName: "Macbook Pro 2022",
        price: 1999.99,
        productImage: product2,
    },
    {
        id: 3,
        productName: "Cole Bennet Camera",
        price: 420.69,
        productImage: product3,
    },
    {
        id: 4,
        productName: "CDG Nike",
        price: 500.00,
        productImage: product4,
    },
    {
        id: 5,
        productName: "LV backpack",
        price: 3999.99,
        productImage: product5,
    },
    {
        id: 6,
        productName: "Off-White",
        price: 688,
        productImage: product6,
    },
    {
        id: 7,
        productName: "CDG Hoodie",
        price: 250.0,
        productImage: product7,
    },
    {
        id: 8,
        productName: "Flawless Like Me Vinyl",
        price: 200.0,
        productImage: product8,
    },
    {
        id: 9,
        productName: "Alternative Trap Vinyl",
        price: 40.0,
        productImage: product9,
    },
    {
        id: 10,
        productName: "TeddyBear Backpack",
        price: 200.0,
        productImage: product10,
    },
    {
        id: 11,
        productName: "Tune Sweater",
        price: 90.0,
        productImage: product11,
    },
    {
        id: 12,
        productName: "CDG Play Hoodie",
        price: 250.0,
        productImage: product12,
    },
    {
        id: 13,
        productName: "Hoodie",
        price: 40.0,
        productImage: product13,
    },
    {
        id: 14,
        productName: "Amiri Jeans",
        price: 420.0,
        productImage: product14,
    }
];